/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    shape, string, number, oneOfType,
    bool, arrayOf, func, object,
    array,
} from 'prop-types';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import ReactHtmlParser from 'react-html-parser';
import { bindActionCreators, compose } from 'redux';
import Image from '../../../../common/Image';
import classList from '../../../../utils/classList';
import { rowSpacing } from '../../../../style/variables';
import { main as mainStyle } from '../../../../style/main';
import { deepObjectExtend, isEmpty } from '../../../../utils/object';
import { decode as htmlDecode } from '../../../../utils/htmlEntity';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configEnv from '../../../../config';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { emitCustomTrackingEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import PriceBreakDownUi from '../../../../../../components/GraphqlComponents/GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceBreakDownUi';

const { PERSIST_KEY } = configEnv;

const styles = ({ typography, palette }) => deepObjectExtend(mainStyle(typography, palette), {
    productWrapper: {
        'text-align': 'center',
        padding: '0 2px',
        borderRadius: '4px',
        overflow: 'hidden',
    },

    productName: { padding: '0 8px' },

    related: {
        '& img': {
            border: 'none',
            width: 'calc(100% - 4px)',
        },
    },

    recommended: {
        'background-color': palette.grey7,

        '& img': {
            border: `solid 2px ${palette.cta1}`,
            width: 'calc(100% - 4px)',
        },
    },
    status: {
        'margin-bottom': rowSpacing,
        'text-transform': 'uppercase',
        'font-size': '10px',
    },
    price: {
        'margin-bottom': rowSpacing,
        'font-weight': 'bold',
        'text-align': 'center',
        padding: '0 8px',
    },
    headerTitle: {
        height: '28px',
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: '13px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
        paddingLeft: '3px',
    },
});

class Recommendation extends Component {
    handleAddToCart = (productId, recipient) => {
        const { handleGiftListAddToCart } = this.props;
        handleGiftListAddToCart(productId, recipient);
    };

    handleAddToCartClicked = (product, recipient, specialProduct) => {
        if (specialProduct) {
            const { seoproductDisplayURL, customAttributes } = product;
            const {
                history,
                history: { location: { pathname: giftListURL } },
                remainingRecipient,
                handleConfirmGiftListShopTheSiteClicked,
            } = this.props;
            const recipientWithCounter = { ...recipient, remainingRecipient, giftListURL };
            handleConfirmGiftListShopTheSiteClicked(
                recipientWithCounter,
                seoproductDisplayURL || customAttributes?.parentProduct?.seo?.url,
                false,
                customAttributes?.deliveryIndicator,
                customAttributes?.productType,
            );
            if (seoproductDisplayURL) history.push(seoproductDisplayURL);
            else if (customAttributes?.parentProduct?.seo?.url) history.push(customAttributes?.parentProduct?.seo?.url);
        } else {
            this.handleAddToCart(product.id, recipient);
        }
    };

    headerProduct = (classes, indexProduct, productNumber, currentPartNumber) => {
        let headerTittle = ' ';
        if (productNumber && currentPartNumber) {
            if (indexProduct === 0) {
                headerTittle = productNumber !== currentPartNumber ? 'Closest Match' : 'Send Same Gift';
            } else if (indexProduct === 1) {
                headerTittle = 'Other Recommendations';
            }
            return <div className={classes.headerTitle}>{headerTittle}</div>;
        }
        return null;
    }

    productTemplate = (
        classes,
        isRecommended,
        product,
        recipient,
        handleGiftListRecommendationClicked,
        indexProduct,
    ) => {
        const {
            id,
            name,
            image,
            status,
            price,
            discountPrice,
            crossedPrice,
            sku,
            customAttributes: { personalization, parentProduct },
            customAttributes,
            hasItemSendPrevious,
        } = product;
        const {
            handleTrackEvent, flags, ldClient, emitCustomClickTrackingEvent, salesforceAPIResponse,
        } = this.props;
        const newName = htmlDecode(name);
        const imageURL = (image) ? image.replace(/^http[s]?:/, 'https:') : '';
        const ageVerifyFlag = (!isEmpty(customAttributes) && customAttributes?.ageVerifyFlag) ? customAttributes.ageVerifyFlag : 'false';
        const personalizationTemplate = (!isEmpty(personalization) && personalization?.personalizationTemplate) ? personalization.personalizationTemplate : 'N';
        const personalizationType = (!isEmpty(personalization) && personalization?.personalizationType) ? personalization.personalizationType : null;
        const specialProduct = ageVerifyFlag !== 'false'
            || parentProduct?.productType === 'CLUB'
            || parentProduct?.productType === 'COLLECTION'
            || parentProduct?.productType === 'CUSTOM_ASSORTMENT'
            || (
                !['REGULAR_PRODUCT', 'REGULARPRODUCT'].includes(parentProduct?.productType)
                && (
                    personalizationTemplate === 'Y'
                    || personalizationType === 'G'
                    || personalizationType === '0'
                )
            );

        const productNumber = recipient.previousItemMetadata?.partNumber || '';
        const currentPartNumber = recipient?.currentItempartNumber || '';
        const currentSalesforceCampaign = salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) ? salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) : {};

        let defaultAddToCartLabel = 'Add To Cart';
        if (specialProduct) {
            defaultAddToCartLabel = 'Make Selections';
        }

        if (isRecommended && hasItemSendPrevious) {
            defaultAddToCartLabel = 'Send Same Gift';
        }

        return (
            <React.Fragment key={id}>
                <div
                    className={classList(
                        `${classes.productWrapper}`,
                        isRecommended && hasItemSendPrevious ? `${classes.recommended}` : `${classes.related}`,
                    )}
                >
                    {this.headerProduct(classes, indexProduct, productNumber, currentPartNumber)}
                    {/* eslint-disable jsx-a11y/click-events-have-key-events */}
                    <div
                        role="button"
                        tabIndex="-1"
                        className={classList(
                            'view-product-detail link',
                            'margin-bottom',
                        )}
                        onClick={() => handleGiftListRecommendationClicked(
                            product,
                            recipient,
                        )}
                    >
                        <Image src={imageURL} alt={newName} />
                        <div className={`${classes.productName} line-clamp-2`}>
                            {ReactHtmlParser(newName)}
                        </div>
                    </div>
                    <div>{sku || id?.split('-')?.[2]}</div>
                    <div className={classes.status}>{status}</div>
                    <div className={classes.price}>
                        {discountPrice && crossedPrice ? (
                            <>
                                <span className="crossed-price">
                                    {crossedPrice}
                                </span>
                                <span className="discount-price">
                                    {discountPrice}
                                </span>
                            </>
                        ) : (
                            `$${price}`
                        )}
                    </div>
                    <Button
                        variant="contained"
                        className={classList(
                            'add-to-cart-btn',
                            'buttonHD',
                            'margin-bottom',
                            'narrow-button',
                            'small-text',
                            'mobile-btn',
                        )}
                        onClick={() => {
                            if (flags?.experimentGiftListV2?.toLowerCase() === 'control') {
                                ldClient.track('Add to Cart');
                            }
                            this.handleAddToCartClicked(product, recipient, specialProduct);
                            handleTrackEvent({
                                eventCategory: 'Gift List V1',
                                eventAction: 'Item Added',
                                eventLabel: product?.id || '',

                                ga_event_name: 'gift_list_interaction',
                                interaction_type: 'add_item',

                            });
                            const isPrimaryItem = !!(isRecommended && hasItemSendPrevious);
                            handleTrackEvent({
                                eventCategory: 'Gift List V1',
                                eventAction: isPrimaryItem ? 'Primary item added' : 'Recommended item added',
                                eventLabel: product?.id || '',

                                ga_event_name: 'gift_list_interaction',
                                interaction_type: 'add_item',
                            });
                            emitCustomClickTrackingEvent({
                                action: 'Click',
                                partNumber: product?.oGPartNumber,
                                salesforceResponse: currentSalesforceCampaign,
                                experimentTracking: product?.experimentTracking,
                                page: { type: 'gift-list' },
                                eventSubType: 'campaign-tracking',
                            });
                        }}
                    >
                        {defaultAddToCartLabel}
                    </Button>
                </div>
            </React.Fragment>
        );
    };

    render() {
        const { classes } = this.props;
        const {
            recipient,
            recipient: { addToCart, products },
            handleGiftListRecommendationClicked,
        } = this.props;
        let slidesToShow = 2.2;
        let slidesToScroll = 2;
        // Increase the number of product on mobile landscape mode/iPad portrait mode
        if (typeof (window) !== 'undefined' && window.innerWidth > 450) {
            slidesToShow = 3.2;
            slidesToScroll = 3;
        }
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow,
            slidesToScroll,
            arrows: false,
            lazyLoad: 'ondemand',
        };

        if (addToCart || isEmpty(recipient) || isEmpty(products)) return null;

        return (
            <>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <Slider className="carousel-container mobile-carousel" {...settings}>
                    {products.map((product, index) => this.productTemplate(
                        classes,
                        index === 0,
                        product,
                        recipient,
                        handleGiftListRecommendationClicked,
                        index,
                    ))}
                </Slider>
            </>
        );
    }
}

Recommendation.defaultProps = {
    addToCart: '',
    history: {},
    recipient: {},
    handleGiftListRecommendationClicked: '',
    handleConfirmGiftListShopTheSiteClicked: () => { },
    handleGiftListAddToCart: () => {},
    ldClient: {},
    salesforceAPIResponse: [],
    emitCustomClickTrackingEvent: () => {},
};

Recommendation.propTypes = {
    classes: object.isRequired,
    history: object,
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                content: string,
                crossedPrice: oneOfType([number, string]),
                discountPrice: oneOfType([number, string]),
                id: string,
                image: string,
                name: string,
                parentCatalogEntryId: string,
                partNumber: string,
                price: number,
                seoproductDisplayURL: string,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    addToCart: string,
    handleGiftListRecommendationClicked: func,
    handleGiftListAddToCart: func,
    remainingRecipient: number.isRequired,
    handleConfirmGiftListShopTheSiteClicked: func,
    handleTrackEvent: func.isRequired,
    ldClient: object,
    flags: object.isRequired,
    salesforceAPIResponse: array,
    emitCustomClickTrackingEvent: func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        remainingRecipient: newState.giftList.remainingRecipient,
        addToCart:
            typeof newState.modal.content === 'object'
                ? newState.modal.content.addToCart
                : '',
        salesforceAPIResponse: newState.giftList.salesforceAPIResponse,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListRecommendationClicked: (product, recipient) => dispatch(EventDispatcher.handleGiftListRecommendationClicked(
        product,
        recipient,
    )),
    handleGiftListAddToCart: (productId, recipient, closeModal) => dispatch(EventDispatcher.handleGiftListAddToCart(
        productId,
        recipient,
        closeModal,
    )),
    handleConfirmGiftListShopTheSiteClicked: (recipient, url, dontShowModal, productType) => dispatch(EventDispatcher.handleConfirmGiftListShopTheSiteClicked(
        recipient,
        url,
        dontShowModal,
        productType,
    )),
    handleTrackEvent: bindActionCreators(trackEvent, dispatch),
    emitCustomClickTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withStyles(styles),
    withLDConsumer(),
);

export default enhance(Recommendation);
